<template>
    <div>
        <a-select size="small" :disabled="selectedObj.disabled" v-model="selectedObj.value">
            <a-select-option v-for="item in items" :value="item" :key="item">{{item}}</a-select-option>
        </a-select>
    </div>
</template>

<script>
    import config from '@/config'

    export default {
        name: "ZGeneralSelect",
        props: ["type","selectedObj"],
        data: function (){
            return {
                items: [],
                defaultValue: null
            }
        },
        created() {
            this.$http.get(config.api.general_data_url + "?name=" + this.type).then((response) => {
                this.items = response.result.content.value
                if(response.result.content.default){
                    this.defaultValue = response.result.content.default
                    this.selectedObj.value = response.result.content.default
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        methods: {
            setDefault(){
                if(this.defaultValue){
                    this.selectedObj.value = this.defaultValue
                }else{
                    this.selectedObj.value = ''
                }
            }
        }

    }
</script>